/* Limpiaclean — mapa de calor anónimo (owner 2026-09-04). ~2 KB, sin cookies,
   sin datos personales. Manda clics/taps (posición relativa al documento),
   el botón/link tocado, hasta dónde bajó y el dispositivo a LIMA APP. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (navigator.doNotTrack === '1' || window.doNotTrack === '1') return;
  var URL = 'https://limpiaclean-lima.netlify.app/api/heatmap-collect';
  var path = location.pathname || '/';
  var device = (window.innerWidth || 0) < 768 ? 'm' : 'd';
  var ref = '';
  try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
  if (ref && /limpiaclean\.com$/i.test(ref)) ref = '';
  var ev = [], maxScroll = 0, t0 = Date.now(), sentView = false, done = false;

  function docSize() {
    var b = document.body, h = document.documentElement;
    return { w: Math.max(h.scrollWidth, h.clientWidth, 1), h: Math.max(b.scrollHeight, h.scrollHeight, h.clientHeight, 1) };
  }
  function label(el) {
    var t = el.closest && el.closest('a,button,input,select,label,summary,[role=button]');
    if (!t) return '';
    var tag = t.tagName.toLowerCase();
    var txt = t.getAttribute('aria-label') || t.getAttribute('title') || '';
    if (!txt && tag === 'input' && t.type !== 'text' && t.type !== 'password') txt = t.value || '';
    if (!txt) txt = t.textContent || t.getAttribute('placeholder') || '';
    txt = String(txt).replace(/\s+/g, ' ').trim();
    if (!txt && tag === 'a') txt = (t.getAttribute('href') || '').replace(/^https?:\/\/[^/]+/, '');
    if (!txt) txt = tag + (t.className && typeof t.className === 'string' ? '.' + t.className.split(' ')[0] : '');
    return (tag === 'a' ? 'link: ' : tag === 'button' ? 'botón: ' : tag + ': ') + txt.slice(0, 40);
  }
  function onTap(e) {
    if (ev.length >= 100) return;
    var s = docSize();
    var x = e.pageX, y = e.pageY;
    if (x == null && e.touches && e.touches[0]) { x = e.touches[0].pageX; y = e.touches[0].pageY; }
    if (x == null) return;
    ev.push({ x: Math.round(1000 * x / s.w), y: Math.round(1000 * y / s.h), el: label(e.target) });
  }
  function onScroll() {
    var s = docSize();
    var pct = Math.round(100 * (window.scrollY + window.innerHeight) / s.h);
    if (pct > maxScroll) maxScroll = Math.min(100, pct);
  }
  function send(final) {
    if (done) return;
    if (!sentView && !final && !ev.length) return;
    var body = { p: path, d: device, r: ref, v: sentView ? 0 : 1, ev: ev.splice(0, ev.length), s: maxScroll, f: final ? 1 : 0, dur: Math.round((Date.now() - t0) / 1000) };
    sentView = true;
    if (final) done = true;
    try {
      var blob = new Blob([JSON.stringify(body)], { type: 'text/plain' });
      if (!(navigator.sendBeacon && navigator.sendBeacon(URL, blob))) {
        fetch(URL, { method: 'POST', body: JSON.stringify(body), keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      }
    } catch (e) {}
  }
  document.addEventListener('click', onTap, { capture: true, passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', function () { onScroll(); setTimeout(function () { send(false); }, 1500); });
  setInterval(function () { if (ev.length) send(false); }, 12000);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(true); });
  window.addEventListener('pagehide', function () { send(true); });
})();
